export const Base_URL = process.env.REACT_APP_SUPERADMIN_API_HOST;
